import React, { CSSProperties } from "react";

interface TranslationIndicatorProps {
  text?: string;
  style?: CSSProperties;
  className?: string;
}

const TranslationIndicator: React.FC<TranslationIndicatorProps> = ({
  text = "(translated)",
  style = {},
  className = "",
}) => {
  const defaultStyle: CSSProperties = {
    color: "grey",
    fontSize: "x-small",
  };

  const combinedStyle = {
    ...defaultStyle,
    ...style,
  };

  return (
    <span style={combinedStyle} className={className}>
      {text}
    </span>
  );
};

export default TranslationIndicator;
